// index.web.js - Fixed web entry point
import React from 'react';
import { createRoot } from 'react-dom/client';
import AppWeb from './app.web.js';

// Get the root element
const container = document.getElementById('root');

// Ensure container exists and is a valid DOM node
if (!container || !(container instanceof HTMLElement)) {
  throw new Error('❌ Root element not found or invalid');
}

// Prevent double mounting (only in dev/hot reload cases)
if (!container._reactRootContainer) {
  const root = createRoot(container);
  root.render(<AppWeb />);
}
